import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useContext } from "react";
import { AppContext } from "../../AppContext";

const ContainerWrapper = styled.div`
	width: 100%;
	text-align: center;
`;
const ContainerContent = styled.div<{ isMobileView: boolean }>(
	({ isMobileView }) => css`
		display: inline-block;
		text-align: center;
		${isMobileView
			? css`
					width: 100%;
			  `
			: css`
					width: 80%;
					max-width: 1000px;
			  `}
	`
);

const Container = (props: any) => {
	const appCtx = useContext(AppContext);
	const { isMobileView } = appCtx;

	return (
		<ContainerWrapper>
			<ContainerContent isMobileView={isMobileView}>
				{props.children}
			</ContainerContent>
		</ContainerWrapper>
	);
};

export default Container;
